.cy{display:inline-flex;}